import { Injectable } from '@angular/core';
import { CanDeactivate, Router } from '@angular/router';
import { UserService } from '../services';
import { ComponentCanDeactivate } from './component-can-deactivate';

@Injectable()
export class CanDeactivateGuard implements CanDeactivate<ComponentCanDeactivate> {
  userData: any = ''
  constructor(private router: Router, private userService: UserService) {
    this.userService.currentUser.subscribe(
      (userData) => {
        this.userData = userData
      })
  }
  canDeactivate(component: ComponentCanDeactivate): boolean {

    if (!component.canDeactivate()) {
      if (confirm(this.userService.translateText('hospital_portal.add_patient.are_you_sure_want_leave.label'))) {
        // if (this.getrouterChange() && this.userData) {
        //   if (this.userData) {
        //     this.userService.logoutuser(this.userData.item.userAccountId)
        //   }
        //   this.userService.purgeAuth();
        //   location.reload();
        // }
        return true;
      } else {
        //   if (this.getrouterChange() && this.userData) {
        //     if (this.userData) {
        //       this.userService.logoutuser(this.userData.item.userAccountId)
        //     }
        //     this.userService.purgeAuth();
        //     location.reload();
        //   }
        return false;
      }

    } return true;
  }
  getrouterChange() {
    if (window.performance.navigation.type == window.performance.navigation.TYPE_RELOAD) {
      return false
    } else {
      return true
    }
  }
}
